export default function getBlockForParaId(contentState, paragraph_id) {
  const blocks = contentState.getBlocksAsArray();
  const index = blocks.findIndex(item => item.getIn(['data', 'id']) === paragraph_id);
  return blocks[index];
}